import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Col, Row } from 'react-bootstrap';
import CookieAgreement from '../cookie_agreement/CookieAgreement';

import styles from './Header.module.scss';

function Header(props) {
  return (
    <header className={styles.header}>
      <CookieAgreement />
      <Grid className={styles.container}>
        <Row>
          <Col md={3}>
            <a href="/">
              <img alt="time-matters" className={styles.logo} src="/images/airmates_logo.svg" />
            </a>
          </Col>
          <Col md={9}>
            {props.navigation}
          </Col>
        </Row>
        {props.children}
      </Grid>
    </header>
  );
}

Header.defaultProps = {
  children: null,
  navigation: null
};

Header.propTypes = {
  children: PropTypes.node,
  navigation: PropTypes.node
};

export default Header;
